/**
 * Canonical Datadog `env` tag for this build, shared by RUM and Logs.
 *
 * Matches the backend APM convention (`env:production`, staging as `env:staging`)
 * so frontend and backend telemetry of one environment line up. It is derived
 * from the build's VITE_ENVIRONMENT (`environment.name`), never from Vite's
 * `import.meta.env.PROD`, which is true for every built bundle, staging included.
 */
export type TelemetryEnv = 'production' | 'staging' | 'development';

export const resolveTelemetryEnv = (environmentName: string | null | undefined): TelemetryEnv => {
  const name = environmentName?.trim().toLowerCase();
  if (name === 'production' || name === 'prod') return 'production';
  if (name === 'staging') return 'staging';
  // Unknown or missing never reports as production.
  return 'development';
};

/**
 * Datadog's own Session Replay sample rate for the build. Staging and production sample every
 * session for Replay so the remote rate decides, and recording still only starts manually, with
 * an 18+ account's explicit consent (services/session-replay). Anything unrecognised never records.
 */
export const resolveSessionReplaySampleRate = (environmentName: string | null | undefined) =>
  resolveTelemetryEnv(environmentName) === 'development' ? 0 : 100;
